import {
    HubConnection,
    HubConnectionBuilder,
    HubConnectionState,
    LogLevel
  } from '@microsoft/signalr'
  import { getModule } from 'vuex-module-decorators'
import ViewingArea from '@/models/ViewingArea'
import LocomotivesModule from '@/store/modules/LocomotivesModule'
import store from '@/store/index'
import LocomotivePosition from '@/models/LocomotivePosition'
import Locomotive from '@/models/Locomotives/Locomotive'
import LocomotiveMapper from './LocomotiveMapper'
import LocoSectionWithParameters from '@/models/Graph/LocoSectionWithParameters'
import LocoSectionError from '@/models/LocomotiveError'

export class SignalRService {
  private hubConnection!: HubConnection
  private locomotiveModule: LocomotivesModule = getModule(LocomotivesModule, store)
  private locomotiveMapper: LocomotiveMapper = new LocomotiveMapper()

  public start(userId: string, area: ViewingArea) {
    this.createConnection(userId, area)
    this.registerOnServerEvents()
    this.startConnection()
  }

  public subscribeToSection(locoSection: string, callback: (data: LocoSectionWithParameters) => void): Promise<void> {
    this.hubConnection.on('SectionParametersAdded', (data: Array<LocoSectionWithParameters>) => {
      callback(data[0])
      // this.locomotiveModule.updateLocomotivesParameters(data[0])
    })
    return this.hubConnection.send('SubscribeOnSectionParameters', locoSection)
  }

  private createConnection(userId: string, area: ViewingArea) {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`/ws/online-hub?userId=${userId}&top=${area.top}&bottom=${area.bottom}&left=${area.left}&right=${area.right}`)
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build()
  }

  private startConnection() {
    if (this.hubConnection.state === HubConnectionState.Connected) {
      return
    }

    this.hubConnection.start().then(
      () => {
        console.log('Hub connection started!')
      },
      error => console.error(error)
    )
  }

  private registerOnServerEvents(): void {
    this.hubConnection.on('LocomotivePositionChanged', (data: Array<LocomotivePosition>) => {
      this.locomotiveModule.updateLocomotivesPositions(data)
    })
    this.hubConnection.on('LocomotiveDataChanged', (data: Array<any>) => {
      debugger
      const locomotivesData = new Array<Locomotive>()

      data.forEach((d) => {
        locomotivesData.push(this.locomotiveMapper.map(d))
      })

      this.locomotiveModule.updateLocomotivesData(locomotivesData)
    })
    this.hubConnection.on('LocoSectionError', (data: LocoSectionError) => {
      this.locomotiveModule.addLocoSectionError(data)
    })
  }
}
